import actionTypes from './actionTypes'
import config from '../../../config/config'
import { logoutUser, returnUserIfUserExists, shouldRedirectUser } from '../../../layouts/LoggedIn/actions'
import { checkJapanese } from '../../../lib'
import { recieveLoginstatus } from '../../Login/actions'

const {
  SHOW_WEBCAM,
  SHOW_UPLOAD,
  REQUEST_UPDATE_DETAILS,
  RECEIVE_UPDATE_DETAILS,
  USER_UPDATED,
  EMAIL_CHANGE,
  CLOSE_SNACKBAR,
  EMAIL_ALREADY_GOT,
  EMAIL_ALREADY_GOT_DISABLE
} = actionTypes

export const closeSnackbar = bool => ({type: CLOSE_SNACKBAR})
export const takePicture = bool => ({type: SHOW_WEBCAM, showWebcam: bool})
export const uploadPicture = bool => ({
  type: SHOW_UPLOAD,
  showUploadOtion: bool
})
export const userUpdated = bool => ({type: USER_UPDATED, userUpdated: bool})

export function updateUserDetails(
  token,
  userid,
  email,
  name,
  password,
  language,
  timezone
) {
  return function (dispatch) {
    dispatch({type: REQUEST_UPDATE_DETAILS})
    const payload = {
      email,
      password,
      name,
      language,
      timezone,
      service_name: 'fvlite'
    }
    return fetch(`${config.URI}/api/v1/profile/${userid}`, {
      method: 'put',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          if (res.data === 'the same email exists') {
            dispatch({type: EMAIL_ALREADY_GOT})
            return
          }

          if (res.data === 'update success with email change') {
            dispatch({type: EMAIL_ALREADY_GOT_DISABLE})
            dispatch({type: EMAIL_CHANGE})
          }

          dispatch(userUpdated(true))
          dispatch({type: RECEIVE_UPDATE_DETAILS})
          setTimeout(() => {
            dispatch(returnUserIfUserExists(token))
          }, 4000)
        } else if (res.errors) {
          dispatch({type: RECEIVE_UPDATE_DETAILS})
        }
      })
      .catch(e => {
        console.error(e)
        
      })
  }
}

export function upgradeUser(token, userid, plan) {
  return function (dispatch) {
    dispatch({type: REQUEST_UPDATE_DETAILS})
    const payload = {
      plan
    }
    return fetch(`${config.URI}/api/v1/profile/${userid}`, {
      method: 'put',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(userUpdated(true))
          dispatch(returnUserIfUserExists(token))
          dispatch({type: RECEIVE_UPDATE_DETAILS})
        } else if (res.errors) {
          dispatch({type: RECEIVE_UPDATE_DETAILS})
        }
      })
      .catch(e => {
        console.error(e)
        
      })
  }
}

export function deleteUser(token, userid) {
  return function (dispatch) {
    dispatch({type: REQUEST_UPDATE_DETAILS})
    return fetch(`${config.URI}/api/v1/profile/${userid}`, {
      method: 'delete',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          sessionStorage.removeItem('authToken');
          localStorage.removeItem('authToken');
          dispatch(recieveLoginstatus(false, {}));
          dispatch(shouldRedirectUser(false));
          dispatch(logoutUser(token));
          console.log(res)
        } else if (res.errors) {
          alert(checkJapanese() ? 'ドメイン所有者は他のユーザーを全て削除するまで、自身を削除できません' : 'Domain owners cannot delete themselves until all other users have been deleted');
          console.error(res.errors)
        }
      })
      .catch(e => {
        console.error(e)
        
      })
  }
}



// WEBPACK FOOTER //
// src/routes/Settings/actions/index.js